const themeContract = {
  argos: {
    filterLabel: {
      backgroundColor: 'brand3',
      color: 'white'
    }
  },
  habitat: {
    filterLabel: {
      backgroundColor: 'brand1',
      color: 'white'
    }
  }
}

export { themeContract }
